import { Component, ReactElement } from 'react'
import Head from 'next/head'
import Accordion from 'Components/Accordion'
import AddressDisplay from 'Components/Cart/AddressDisplay'
import AppBar from 'Components/AppBar'
import Breadcrumb from 'Components/Breadcrumb'
import Calendar from 'Components/Checkout/Calendar'
import CustomerServiceBox from 'Components/CustomerServiceBox'
import Footer from 'Components/Footer'
import { ViewType as AppBarViewType } from 'Components/AppBar/AppBar'

import {
  SVGDropPackage,
  SVGPackage,
  SVGShipping2,
  SVGShippingCar,
  SVGArrowBack
} from 'Components/SVGCollection'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import csb from 'Components/CustomerServiceBox/CustomerServiceBox.scss'
import plph from 'Components/ProductListPage/components/ProductListPageHeader/ProductListPageHeader.scss'
import prnt from 'Scss/pages/article.scss'
import { connect } from 'react-redux'
import { shippingMethodsQuery } from 'Utils/api/gql/queries/shippingMethods'
import { Query } from 'react-apollo'
import { shippingMethods, shippingMethods_shippingMethods, shippingMethods_shippingMethods_ShippingMethodPostPoint, shippingMethods_shippingMethods_ShippingMethodGRoby, shippingMethods_shippingMethods_ShippingMethodMpl, shippingMethods_shippingMethods_ShippingMethodGPoint, ShippingMethodFragment_ShippingMethodGRoby } from 'Utils/api/gql/types'
import LoadingPage from 'Components/LoadingPage'
import Markdown from 'react-markdown'
import { weightFormatter, numberFormatter, priceIntervalFormatter } from 'Utils/helpers/formatters'
import { isTimeTableData } from 'Components/Checkout/DeliveryGroby/DeliveryGroby'
import { goBack } from 'Utils/helpers/routerHelper';
import animateScrollTo from 'animated-scroll-to';
import { SCROLL_OPTIONS } from 'Utils/helpers/misc';
import { AppContext } from 'Utils/withReduxStore';
import { formatBreadcrumbForGtm } from 'Components/Breadcrumb/Breadcrumb';
import { priceRangeFormatter } from "../utils/helpers/formatters";
import { freeShippingPriceRange } from "../utils/helpers/constants";

type ReduxProps = {
  session: Redux.IStoreSessionData
  deliveryAddress: Redux.IDeliveryAddress | undefined
}

type OwnProps = {
  grobyOpened: boolean
}

type PropType = ReduxProps & OwnProps

class DeliveryInformationPage extends Component<PropType> {
  csomagfutar: HTMLHeadingElement | null = null

  static async getInitialProps(ctx: AppContext): Promise<OwnProps> {
    if (ctx.query.opened === 'csomagfutar') {
      return { grobyOpened: true }
    } else {
      return { grobyOpened: false }
    }
  }

  componentDidMount() {
    if (this.props.grobyOpened) {
      setTimeout(() => animateScrollTo(this.csomagfutar || 0, SCROLL_OPTIONS), 500)
    }
  }

  private renderCommonProps(shippingMethod: shippingMethods_shippingMethods) {
    if (shippingMethod) {
      return (
        <>
          {shippingMethod.max_weight ? (<><h5>Súlykorlát</h5><p>{weightFormatter(shippingMethod.max_weight)}</p></>) : ''}
          {shippingMethod.delivery_time ? (<><h5>Szállítási idő</h5><p><Markdown source={shippingMethod.delivery_time || ''} /></p></>) : ''}
        </>
      )
    }
  }

  private renderInfo(shippingMethod: shippingMethods_shippingMethods) {
    return (
      <>
        <Markdown source={shippingMethod.description || ''} />
        {this.renderCommonProps(shippingMethod)}
      </>
    )
  }
  
  private renderPriceRanges(method: shippingMethods_shippingMethods_ShippingMethodPostPoint | shippingMethods_shippingMethods_ShippingMethodMpl): React.ReactNode {
    if (!method.price_ranges || !method.price_ranges.length) {
      return `${numberFormatter(method.price)} Ft`
    }
    if (method.price_ranges.length === 1) {
      return `${numberFormatter(method.price_ranges[0].price)} Ft`
    }
    return [...method.price_ranges]
      .sort((a,b) => a.from - b.from)
      .map(priceRangeFormatter)
      .map(formatted => <>{formatted}<br /></>)
  }

  private renderPostPoint (PostPoint: shippingMethods_shippingMethods_ShippingMethodPostPoint | undefined) {
    if (PostPoint) {
      return (
        <Accordion ariaId="csomagpont" ariaLevel={3} opened={true}
        renderHeader={
          <h3 className={cn(cg.h3, prnt.h3)}>Csomagpont</h3>
        }
      >
        <div className={prnt.accordionContent}>
          <div className={cn(prnt.iconInformationHeader)}>
            <div className={cn(cg.gridX, cg.alignMiddle)}>
              <div className={cn(cg.cell, cg.shrink)}>
                <SVGDropPackage width={32} height={32} />
              </div>
              <div className={cn(cg.cell, cg.auto)}>
                <h4>
                  {PostPoint.name}<br />
                  <strong>{this.renderPriceRanges(PostPoint)}</strong>
                </h4>
              </div>
            </div>
          </div>
          <div>
            {this.renderInfo(PostPoint)}
          </div>
        </div>


      </Accordion>
      )
      }
  }

  private renderGPoint (GPoint: shippingMethods_shippingMethods_ShippingMethodGPoint | undefined) {
    if (GPoint) {
      return (
        <Accordion
        ariaId="szemelyes-atvetel"
        ariaLevel={3}
        renderHeader={
          <h3 className={cn(cg.h3, prnt.h3)}>Személyes átvétel</h3>
        }
        opened={true}
      >

      <div className={prnt.accordionContent}>
        <div className={cn(prnt.iconInformationHeader)}>
          <div className={cn(cg.gridX, cg.alignMiddle)}>
            <div className={cn(cg.cell, cg.shrink)}>
              <SVGPackage width={32} height={32} />
            </div>
            <div className={cn(cg.cell, cg.auto)}>
              <h4>
                {GPoint.name}<br />
                <strong>{priceIntervalFormatter(GPoint.price)}</strong>
              </h4>
            </div>
          </div>
        </div>
        <div>
          {this.renderInfo(GPoint)}
        </div>
      </div>

      </Accordion>
      )
    }
  }

  private renderCalendar() {
    if (!(this.props.deliveryAddress && this.props.deliveryAddress.value.zip)) {
      // TODO TEMPORARY
      // return <p> A szállítási idősávok területenként változnak. Kérjük add meg, hogy hova szerentél házhozrendelni!</p>
      return null
    }


    const variables = {postcode: this.props.deliveryAddress.value.zip}

    return (
      <Query<shippingMethods>
          query={shippingMethodsQuery}
          partialRefetch={true}
          variables={variables}
      >
          {({ error, data }) => {
              if (!error && data && data.shippingMethods) {
                const grobyShipping = data.shippingMethods.find(method => !!method && method.__typename === 'ShippingMethodGRoby') as ShippingMethodFragment_ShippingMethodGRoby
                if (grobyShipping) {
                  const timeTableEntries = grobyShipping.data.filter(isTimeTableData)
                  return (
                    <>
                      <h2 className={cn(cg.h3, prnt.h3)}>Kiszállítási kalkulátor</h2>
                      <h5>Az általad megadott címre saját futárszolgálatunk is szállít. Az alábbi szabad időpontok közül választhatsz a {this.props.deliveryAddress!.value.zip} irányítószámra:</h5>
                      <Calendar timeTableEntries={timeTableEntries} selectedSlotId={null} onChange={() => {}} />
                      <p>A kalkulátor által jelzett időponthoz képest a rendelés leadásakor kiválasztható szabad időpontok a telítődés függvényében eltérhetnek!</p>
                    </>
                  )
                }
                return null;
                // TODO TEMPORARY
                // return (
                //   <p>
                //     A GRoby futárszolgálat a {this.props.deliveryAddress!.value.zip} irányítószámra egyelőre nem elérhető, de Csomagfutárral Magyarország egész területére elérhető házhozszállítási szolgáltatásunk.
                //   </p>
                // )
              }
              return ''
            }
          }
      </Query>
    )
  }

  private renderDelivery(GRoby: shippingMethods_shippingMethods_ShippingMethodGRoby | undefined, Mpl: shippingMethods_shippingMethods_ShippingMethodMpl | undefined) {
    const GRobyOption = !GRoby ? '' : (
      <div className={prnt.accordionContent}>
        <div className={cn(prnt.iconInformationHeader)}>
          <div className={cn(cg.gridX, cg.alignMiddle)}>
            <div className={cn(cg.cell, cg.shrink)}>
              <SVGShippingCar width={32} height={32} />
            </div>
            <div className={cn(cg.cell, cg.auto)}>
              <h4>
                {GRoby.name}<br />
                <strong>{priceIntervalFormatter(GRoby.price)}</strong>
              </h4>
            </div>
          </div>
        </div>
        <div>
          {this.renderInfo(GRoby)}
        </div>
      </div>
    )

    const MplOption = !Mpl ? '' : (
      <div className={prnt.accordionContent}>
        <div className={cn(prnt.iconInformationHeader)}>
          <div className={cn(cg.gridX, cg.alignMiddle)}>
            <div className={cn(cg.cell, cg.shrink)}>
              <SVGShipping2 width={32} height={32} />
            </div>
            <div className={cn(cg.cell, cg.auto)}>
              <h4 ref={ref => this.csomagfutar = ref}>
                {Mpl.name}<br />
                <strong>{this.renderPriceRanges(Mpl)}</strong>
              </h4>
            </div>
          </div>
        </div>
        <div>
          {this.renderInfo(Mpl)}
        </div>
      </div>
    )

    return (
      <Accordion
      ariaId="kiszallitas"
      ariaLevel={3}
      renderHeader={
        <h3 className={cn(cg.h3, prnt.h3)}>Házhozszállítás</h3>
      }
      defaultOpened={this.props.grobyOpened}
    >
      {GRobyOption}
      {MplOption}
    </Accordion>

    )
  }

  private renderContent = (shippingMethods: (shippingMethods_shippingMethods | null)[]) => {
    let GRoby, PostPoint, Mpl, GPoint
    const result: (JSX.Element | undefined)[] = []

    shippingMethods.forEach(method => {
      if (method) {
        if (method.__typename === 'ShippingMethodGRoby') {
          GRoby = method
        }
        if (method.__typename === 'ShippingMethodMpl') {
          Mpl = method
        }
        if (method.__typename === 'ShippingMethodPostPoint') {
          PostPoint = method
        }
        if (method.__typename === 'ShippingMethodGPoint') {
          GPoint = method
        }
      }
    })

    if (GRoby || Mpl) {
      result.push(this.renderDelivery(GRoby, Mpl))
    }

    if (PostPoint) {
      result.push(this.renderPostPoint(PostPoint))
    }

    if (GPoint) {
      result.push(this.renderGPoint(GPoint))
    }

    return result
  }

  render() {

    const breadcrumbData = [
      {
        href: '/',
        title: 'Főoldal',
        gtmName: 'Home'
      },
      {
        href: '/szallitas',
        title: 'Szállítási információk',
        gtmName: 'Delivery Information'
      }
    ]

    return (
      <div>
        <Head>
          <title>Szállítási információk</title>
        </Head>

        <AppBar
          viewType={AppBarViewType.SubPage}
          pageTitle="Szállítási információk"
          pageType="Home"
          breadcrumb={formatBreadcrumbForGtm(breadcrumbData)}
        />
        <Query<shippingMethods>
                query={shippingMethodsQuery}
                partialRefetch={true}
            >
                {({ error, data, refetch }) => {
                    if (error) {
                        return null
                    }

                    if (data && data.shippingMethods) {
                        return (
                          <div className={cn(cg.gridContainer, prnt.articlePage__mainContainer)}>
                            <div className={cn(cg.showForMedium, prnt.articlePage__breadcrumbContainer)}>
                              <Breadcrumb data={breadcrumbData} />
                            </div>

                            <div className={cn(cg.gridX, plph.productListPage__header, cg.showForLarge)}>
                              <div className={cn(cg.cell, cg.shrink)}>
                                <a className={plph.linkBack} onClick={goBack}>
                                  <span className={cg.showForSr}>
                                      Vissza
                                  </span>

                                  <span aria-hidden="true">
                                      <SVGArrowBack width="32" height="32" />
                                  </span>
                                </a>
                              </div>
                              <div className={cn(cg.cell, cg.auto)}>
                                <h1 className={plph.h1}>
                                  Szállítási információk
                                </h1>
                              </div>
                            </div>
                            <div className={cn(prnt.articleContent)}>
                              <div className={prnt.articlePage__mainIsFullWidth}>
                                <AddressDisplay view="CartPage" />
                              </div>

                              <h2 className={cn(cg.h3, prnt.h3)}>Szállítási és átvételi módok</h2>
                            {/* TODO TEMPORARY */}
                              {/* <p>
                                Az alábbiakban a GRoby webáruházban elérhető valamennyi szállítási módot látod.
                                A GRoby termékeit országosan az MPL segítségével juttatja el a megrendelőhöz, válaszható házhozszállítás és PostaPonti átvétel is.
                                Budapesten és vonzáskörzetében saját futáros kiszállításunkat is választhatod.
                                Természetesen bárki leadhatja megrendelését személyes átvétellel is. Rendelésed ebben az esetben a GRoby Netshop raktárjában veheted át.
                                <br /><br />
                                Szeretnénk felhívni figyelmedet, hogy az egyes átvételi módoknál az egy rendelés alkalmával leadható kosár maximális tömege eltér, valamint az MPL korlátozott termékkört szállít ki.
                                A kényelmes vásárálás érdekében már a vásárlás megkezdésekor szükséges megadni az átvétel helyét, így csak azokat a termékeket kínáljuk, amelyeket ki tudunk szállítani neked és tudunk figyelmeztetni, ha a kosarad össztömege meghaladja a korlátot.
                                <br /><br />
                                Az árakról, tömegkorlátokról, kiszállítási feltételekről az alábbiakban tájékozódhatsz.
                              </p> */}

                              {this.renderCalendar()}

                              <div className={prnt.articlePage__mainIsFullWidth}>

                                {this.renderContent(data.shippingMethods)}

                                <div className={prnt.articlePage__cutomerServiceBoxWrapper}>
                                  <CustomerServiceBox className={cn(csb.compact)} />
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                    }

                    return <LoadingPage />
                }}
            </Query>
        <Footer />
      </div>
    )
  }
}

export default connect<ReduxProps, {}, {}, Redux.IReduxState>(({ session, deliveryAddress }) =>
  ({
    session,
    deliveryAddress
  })
)(DeliveryInformationPage)
